var map = {
	"./logo-branco-amorsaude copy.svg": "d645",
	"./logo-branco-amorsaude.svg": "331d",
	"./logo-branco-cna.svg": "e2b5",
	"./logo-branco-drogasil copy.svg": "119f",
	"./logo-branco-drogasil.svg": "48e4",
	"./logo-branco-estacio.svg": "3821",
	"./logo-branco-raia copy.svg": "3d77",
	"./logo-branco-raia.svg": "26ba",
	"./logo-branco-refuturiza copy.svg": "3d7e",
	"./logo-branco-refuturiza.svg": "d629",
	"./logo-branco-ultragaz.svg": "0aa2",
	"./logo-preto-amorsaude copy.svg": "2e20",
	"./logo-preto-amorsaude.svg": "5180",
	"./logo-preto-cna.svg": "01d7",
	"./logo-preto-drogasil.svg": "ef15",
	"./logo-preto-estacio.svg": "dfc2",
	"./logo-preto-raia.svg": "7a8a",
	"./logo-preto-refuturiza.svg": "6d70",
	"./logo-preto-ultragaz.svg": "64b0"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "2921";